import React, { useState, useRef, useEffect } from 'react';
import { FolderOpen } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const Files = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { title: 'BlogWriter', path: '/files/blogWriter' },
    // { title: 'Social Media Generator', path: '/files/socialMedia' },
    { title: 'Text to Image', path: '/files/textToImage' },
    { title: 'Text to Logo', path: '/files/textToLogo' },
    { title: 'Image Editor Tools', path: '/files/imageEditor' },
    { title: 'GIF Maker', path: '/files/gifMaker' },
  ];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleNavigation = (path: string) => {
    navigate(path);
    setIsOpen(false);
  };

  return (
    <div className="relative inline-block z-50" ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        className="p-2 hover:bg-[#846CEC] hover:text-white rounded-sm text-[#846CEC] transition-colors"
        aria-expanded={isOpen}
        aria-haspopup="true"
        aria-label="Open file menu"
      >
        <FolderOpen size={18} />
      </button>

      {isOpen && (
        <div
          className="absolute top-full -right-4 mt-1 w-48 bg-background rounded-md shadow-lg border border-stroke-regular"
          role="menu"
          aria-orientation="vertical"
        >
          <div className="py-1">
            {menuItems.map((item, index) => {
              const isActive = location.pathname === item.path;
              return (
                <button
                  key={index}
                  className={`w-full px-4 py-2 text-left text-sm ${
                    isActive
                      ? 'bg-[#846CEC] text-text-primary'
                      : 'text-text-primary hover:bg-gray-100 hover:dark:text-black'
                  } transition-colors`}
                  onClick={() => handleNavigation(item.path)}
                  role="menuitem"
                  aria-current={isActive ? 'page' : undefined}
                >
                  {item.title}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default Files;
